import ResourcesIcon from 'assets/left_navbar_icons/resources.svg?react';
import peopleRoutes from './People';
import companyRoutes from './Companies';
import equipmentRoutes from './Equipment';

const routes = [
  {
    id: 'resources',
    key: 'resources',
    label: 'Resources',
    path: 'resources',
    exact: true,
    secure: true,
    disabled: false,
    icon: ResourcesIcon,
    nav: 'leftNav',
    subRoutes: [
      ...peopleRoutes.navRoutes,
      ...companyRoutes.navRoutes,
      ...equipmentRoutes.navRoutes
    ]
  },
  ...peopleRoutes.allRoutes,
  ...companyRoutes.allRoutes,
  ...equipmentRoutes.allRoutes
];

export default routes;
